import {
    capitalize,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Tool} from "../../api";
import {useTools, useMandanten} from "../../client/queries";
import MultipleGuard from "../../components/guards/MultipleGuard";
import ErrorAlert from "../../components/ErrorAlert";
import Layout from "../../components/Layout";
import {permissions} from "../../permissions";
import {notPermitted} from "../../errors";
import ToolingRow from "../../components/tooling/ToolingRow";

export default function PageTooling() {
    const {t: translation} = useTranslation('tooling');
    const tools = useTools({limit: 100});
    const mandanten = useMandanten({limit: 1000});

    return (
        <Layout>
            <MultipleGuard
                permissions={[permissions.tools.edit]}
                fallback={<ErrorAlert error={notPermitted()}/>}
            >
                <Paper sx={{p: 2}}>
                    <Stack spacing={2}>
                        <div>
                            <Typography variant="h6">{capitalize(translation('tooling-title'))}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {translation('tooling-description')}
                            </Typography>
                        </div>
                        <TableContainer component={Paper} variant="outlined">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{capitalize(translation('tool-name'))}</TableCell>
                                        <TableCell>{capitalize(translation('tool-stage'))}</TableCell>
                                        <TableCell>{capitalize(translation('tool-global'))}</TableCell>
                                        <TableCell>{capitalize(translation('tool-mandanten'))}</TableCell>
                                        <TableCell align="right">{capitalize(translation('tool-actions'))}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tools.items.map((tool: Tool) => (
                                        <ToolingRow
                                            key={tool.id}
                                            tool={tool}
                                            mandanten={mandanten.items}
                                        />
                                    ))}
                                    {tools.items.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Typography color="text.secondary" variant="body2">
                                                    {translation('tooling-empty')}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Stack>
                </Paper>
            </MultipleGuard>
        </Layout>
    );
}
